module.exports = __webpack_public_path__ + "img/title-bg.8f195c0f.png";